/* eslint-disable */
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import dayjs from "utils/dayjs";
import queryString from 'query-string';

import { Box, Button, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { DataGridPro, koKR, enUS, zhCN } from '@mui/x-data-grid-pro';

import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput, orderNumber, periodSearchSelectItems, ROLE } from 'data/data';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import {  getEquipmentAlertsByQuery, getEquipmentAlertsByQueryString, getEquipmentAlertsGroupCountByFllwActionType } from 'components/axios/equipmentAlertsAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import ConstantInspectionModal from 'components/modal/ConstantInspectionModal';
import PageInfo from 'components/PageInfo';
import { fromServerFormat } from 'components/date_picker/dateUtils';
import { getSearchFiltersEquipmentZones } from 'components/axios/equipmentZoneAxios';
import CommonLargeExcelDownload from 'components/CommonLargeExcelDownload';
import useConfig from 'hooks/useConfig';
import usePermission from 'hooks/usePermission';
import { PERMISSIONS } from 'config/permissions';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const EquipmentAlertHistoryTrackingMonitoring = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s, role, loginInfo } = useEnumApi();
    const { t, i18n } = useTranslation();
    const { mode } = useConfig();

    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const nantongCompanyId = process.env.REACT_APP_NANTONG_MANAGEMENT_COMPANY_NO;
    const lang = i18n.language.substring(0, 2);

    const selectPeriodOptions = useMemo(() => {
        return periodSearchSelectItems.map(item => ({
            code: item.code,
            title: t(item.titleKey)
        }));
    }, [t, i18n.language]); // 언어 변경 시 자동 재계산

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 20);
    const [equipmentAlerts, setEquipmentAlerts] = useState([]);
    const [isLoading, setIsLoading] = useState(true); // 화면 로딩 전용
    const [refreshKey, setRefreshKey] = useState(0);  // 목록 재조회 트리거
    const [isParam, setIsParam] = useState(false);
    
    const [zoneCategoryCode, setZoneCategoryCode] = useState('');
    const [zoneId, setZoneId] = useState('');
    const [equipmentFollowActionType, setEquipmentFollowActionType] = useState('');
    const [equipmentFollowActionStatus, setEquipmentFollowActionStatus] = useState('');
    const [equipmentAlertStatus, setEquipmentAlertStatus] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [periodSearch, setPeriodSearch] = useState('');
    const [alertType, setAlertType] = useState('');
    const [alertCategory, setAlertCategory] = useState('');
   
    const [zoneCategories, setZoneCategories] = useState([]);
    const [zones, setZones] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  
    const [sortModel, setSortModel] = useState(null);
    const excelTitle = t('menu.cmms.equipment-alert-history-tracking');
    const excelTopHeaders = [
      'No.',
      t('message.common.subtitle.status')
      , t('message.common.subtitle.fllwActionType')
      , t('message.common.subtitle.fllwActionStatus')
      , t('message.common.subtitle.fieldChkedAt')
      , t('message.common.subtitle.alertedAt')
      , t('message.common.subtitle.fieldChkUser')
      , t('message.common.subtitle.alertType')
      , t('message.common.subtitle.alertCategory')
      , getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title
      , getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title
      , t('message.common.subtitle.equipment.level1')
      , t('message.common.subtitle.equipment.level3')
      , t('message.common.subtitle.equipment.name')
      , t('message.common.subtitle.equipment.number')
      , getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title
      , t('message.common.subtitle.modelName')
    ];
    const [excelParam, setExcelParam] = useState([]);
    // const fileName = excelTitle+"_"+Date.now();
    // const [excelDatas, setExcelDatas] = useState([]);

    if (platformServer === 'NANTONG') {
      excelTopHeaders.splice(9, 2)

      // 호선, 역사 추가
      excelTopHeaders.splice(9, 0, t('message.common.subtitle.subwayline')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      excelTopHeaders.splice(10, 0, t('message.common.subtitle.station')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    }

    const [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
    const [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
    // const toDate = new Date();

    const searchFields = [
      {code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}, {code:"modelName", title:t('message.common.subtitle.modelName')}
      // , {code:"mfr", title:getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title}, {code:"man", title:getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title}, {code:"mnt", title:getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title}
    ];

    const requestRefresh = useCallback(() => {
      setRefreshKey(prev => prev + 1);
    }, []);
  
    let qs = queryString.parse(window.location.search);

    let followActionTypeSelectColor = "";
    if (equipmentFollowActionType === '' || equipmentFollowActionType === "sum") {
      followActionTypeSelectColor = " selected";
    }
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');
    
    const { hasPermission } = usePermission();
    const constantInspectionPermission = hasPermission(PERMISSIONS.CONSTANT_INSPECTION_WRITE);

    let columns = [
      { field: 'no', headerName: 'No.', sortable: false, width: 80
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.no}</Link>)
      },
      { field: 'status', headerName: t('message.common.subtitle.status'), sortable:true, width: 80
        , renderCell:(params)=> {
          const getColor = () => {
            switch(params.row?.status){
              case "D":
                return " condition1";
              case "F":
                return " condition2";
              case "M":
                return " condition4";
              default:
                return "";
            }
          };
          return (
          <div style={{textAlign:"center"}} className={getColor()}>
            <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentAlertStatus", params.row?.status)?.[0]?.title}</Link>
          </div>)
        }
      },
      { field: 'fllwActionType', headerName: t('message.common.subtitle.fllwActionType'), sortable:true, width: 100
        , renderCell:(params)=>{
          const getColor = () => {
            switch(params.row?.fllwActionType){
              case "O1_WAIT":
                return " condition1";
              case "O2_OBSERVE":
                return " condition2";
              case "O3_MNT":
                return " condition5";
              case "O4_NORMAL":
                return " condition6";
              default:
                return "";
            }
          };
          return (
          <div style={{textAlign:"center"}} className={getColor()}>
            <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("FollowActionType", params.row?.fllwActionType)?.[0]?.title}</Link>
          </div>)
        }
      },
      { field: 'fllwActionStatus', headerName: t('message.common.subtitle.fllwActionStatus'), sortable:false, width: 80
        , renderCell:(params)=>{
          let getColor = () => '';
          let statusName = '';
          if (params.row?.fllwActionType === 'O2_OBSERVE') {
            if (params.row?.atentObserv?.status) { // 주의관찰의 상태값이 있으면
              statusName = getEnumValueByEnumNameAndCode("AttentionObservationStatus",params.row?.atentObserv?.status)?.[0]?.title;
              getColor = () => {
                switch(params.row?.atentObserv?.status){
                  case "V": // 유효
                    return "condition2";
                  case "R": // 해제
                    return "condition4";
                  default:
                    return "";
                }
              };
            }
          } else if (params.row?.fllwActionType === 'O3_MNT') {
            if (params.row?.mntTask?.status) {  // 유지보수의 상태값이 있으면
              statusName = getEnumValueByEnumNameAndCode("MaintenanceStatus",params.row?.mntTask?.status)?.[0]?.title;
              getColor = () => {
                switch(params.row?.mntTask?.status){
                  case "O1_R":  // 대기
                    return "condition1";
                  case "O2_P":  // 진행중
                    return "condition2";
                  case "O3_C":  // 완료
                    return "condition5";
                  case "O4_V":  // 확인
                    return "condition6";
                  default:
                    return "";
                }
              };
            }
          }
          return (
          <div style={{textAlign:"center"}} className={getColor()}>
            <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{statusName}</Link>
          </div>)
        }
      },
      { field: 'fieldChkedAt', headerName: t('message.common.subtitle.fieldChkedAt'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.fieldChkedAt && fromServerFormat(params.row?.fieldChkedAt, {format:t('message.common.text.date.format.datetime')})}</Link>)
      },
      { field: 'latestAlertedAt', headerName: t('message.common.subtitle.alertedAt'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.latestAlertedAt && fromServerFormat(params.row?.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})}</Link>)
      },
      { field: 'fieldChkUser', headerName: t('message.common.subtitle.fieldChkUser'), sortable:false, width: 100
        , renderCell:(params)=>(
          params.row?.status === 'D' ? constantInspectionPermission ?
          <div style={{textAlign:"center", width:"100%"}}><ConstantInspectionModal alertId={params.row?.id} onRefresh={requestRefresh} type="icon" /></div> : ""
          :
          <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString} style={{textAlign:"center", width:"100%"}}>{params.row?.fieldChkUser}</Link>
        )
      },
      { field: 'alertType', headerName: t('message.common.subtitle.alertType'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertType", params.row?.alertType)?.[0]?.title}</Link>)
      },
      { field: 'alertCategory', headerName: t('message.common.subtitle.alertCategory'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertCategory", params.row?.alertCategory)?.[0]?.title}</Link>)
      },
      { field: 'equipment.managementCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title, sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.managementCompany?.info?.name}</Link>)
      },
      { field: 'equipment.maintenanceCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MNT')?.[0]?.title, sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.maintenanceCompany?.info?.name}</Link>)
      },
      { field: 'equipment.equipmentCtgr.parent.parent.name', headerName: t('message.common.subtitle.equipment.level1'), sortable:true,  width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.parent?.name}</Link>)
      },
      { field: 'equipment.equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 130
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.name}</Link>)
      },
      { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
      },
      { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
      },
      { field: 'equipment.manufacturingCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MFR')?.[0]?.title, sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.manufacturingCompany?.info?.name}</Link>)
      },
      { field: 'equipment.modelName', headerName: t('message.common.subtitle.modelName'), sortable:true, width: 80
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.modelName}</Link>)
      },
    ];

    if (platformServer === 'NANTONG') {
      // 관리주체 항목 제거
      const targetIndex = columns.findIndex(item => item.field === 'equipment.managementCompany.info.name');
      if (targetIndex !== -1) {
        columns.splice(targetIndex, 2); // targetIndex부터 1개를 삭제
      }

      // 호선, 역사 추가
      const newItem = { field: 'equipment.zone.category.code', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 80
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.zone?.category?.name?.[i18n.language.substring(0, 2)]}</Link>)
      };
      const newItem2 = { field: 'equipment.zone.name', headerName: t('message.common.subtitle.station'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.zone?.name}</Link>)
      };
      columns.splice(9, 0, newItem); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      columns.splice(10, 0, newItem2); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    }

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);
      
      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "status,asc"});
        searchOrders.push({sort : "latestAlertedAt,desc"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page)};
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
  
        if (qs.searchStatus) setEquipmentAlertStatus(qs.searchStatus);
        if (qs.searchFollowActionType) setEquipmentFollowActionType(qs.searchFollowActionType);
        if (qs.searchFollowActionStatus) setEquipmentFollowActionStatus(qs.searchFollowActionStatus);
        if (qs.searchAlertType) setAlertType(qs.searchAlertType);
        if (qs.searchAlertCategory) setAlertCategory(qs.searchAlertCategory);
        if (qs.searchSubway) setZoneCategoryCode(qs.searchSubway);
        if (qs.searchStation) setZoneId(qs.searchStation);
        if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
        if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
        if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);
        if (qs.periodSearch >= 0) setPeriodSearch(qs.periodSearch);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchFollowActionType) {searchParamCopy.searchFollowActionType = qs.searchFollowActionType};
        if (qs.searchFollowActionStatus) {searchParamCopy.searchFollowActionStatus = qs.searchFollowActionStatus};
        if (qs.searchAlertType) {searchParamCopy.searchAlertType = qs.searchAlertType};
        if (qs.searchAlertCategory) {searchParamCopy.searchAlertCategory = qs.searchAlertCategory};
        if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
        if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
        if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
        if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
        if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
        if (qs.periodSearch >= 0) {searchParamCopy.periodSearch = qs.periodSearch};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>orders.push({sort:order}));
            qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchFollowActionType, qs.searchFollowActionStatus, qs.searchStatus, qs.searchSubway
      , qs.searchAlertType, qs.searchAlertCategory, qs.searchStation, qs.searchlevel1, qs.searchlevel2, qs.searchlevel3, qs.periodSearch]);
    
    // }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchFollowActionStatus, qs.searchStatus
    //   , qs.searchAlertType, qs.searchAlertCategory
    //   , qs.searchFollowActionType, qs.periodSearch
    //   , qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

    useEffect(() => {
      const fetchAndSetZones = async () => {
        const data = await getSearchFiltersEquipmentZones();
        if (!data) return;

        const company = data.managementCompanies?.find(com => com.id == nantongCompanyId);
        if (company) {
          const categories = company.zoneCategories?.map(zc => ({
            ...zc,
            title: zc.name?.[lang]
          })) ?? [];
          
          setZoneCategories(categories);

          // 카테고리 로드 직후, 현재 선택된 zoneCategoryCode가 있다면 바로 zones까지 세팅
          if (zoneCategoryCode) {
            const foundCategory = categories.find(zc => zc.code === zoneCategoryCode);
            setZones(foundCategory?.zones ?? []);
          }
        }
      };

      fetchAndSetZones();
    }, [nantongCompanyId, lang, zoneCategoryCode]); // 관련 의존성을 통합

    useEffect(()=>{
      // console.log(zoneCategories)
      if (zoneCategoryCode) {
        const zonCategory = zoneCategories?.find(zc=>zc.code === zoneCategoryCode);
        setZones(zonCategory?.zones ?? [])
        // console.log(zonCategory)
        // console.log(zonCategory?.zones ?? [])
      } else {
        setZones([])
        // console.log(111)
      }
    },[zoneCategoryCode])
    
    // 설비중분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel1Id) {
        const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel2s(list);
            } else {
              setEquipmentCategoryLevel2s([]);
            }
          } else {
            setEquipmentCategoryLevel2s([]);
          }
          setEquipmentCategoryLevel3s([]);
        });
      }
    },[equipmentCategoryLevel1Id]);
  
    // 설비분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel2Id) {
        const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel3s(list);
            } else {
              setEquipmentCategoryLevel3s([]);
            }
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        });
      }
    },[equipmentCategoryLevel2Id]);

    useEffect(() => {
      if (!isParam) return;
      if (!getEnumValueByEnumName("FollowActionType")) return;
      if (isNaN(currentPage)) return;

      fetchEquipmentAlerts();
    }, [
      currentPage,
      pageSize,
      sortModel,
      refreshKey,
      isParam,
      getEnumValueByEnumName("FollowActionType")
    ]);

    const fetchEquipmentAlerts = async (page = currentPage) => {
      const targetPage = isNaN(page) ? 0 : page;
      setCurrentPage(targetPage);

      if (isNaN(pageSize)) {
        setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
      }

      setIsLoading(true);

      let param = {
        page: targetPage,
        size: pageSize,
        "equipment.iotInstlYn": true,
        // AlertType: "IOT",
      };

      let countParam = { ...param };

      /** =======================
       *  필터 조건
       * ======================= */
      if (equipmentAlertStatus) {
        param.status = equipmentAlertStatus;
      }

      if (equipmentFollowActionType !== 'sum') {
        param.fllwActionType = equipmentFollowActionType;
        if (equipmentFollowActionStatus && equipmentFollowActionStatus !== 'null') {
          if (equipmentFollowActionType === 'O2_OBSERVE') {
            param['atentObserv.status'] = equipmentFollowActionStatus;
          } else if (equipmentFollowActionType === 'O3_MNT') {
            param['mntTask.status'] = equipmentFollowActionStatus;
          }
        }
      }

      if (alertType) {
        param.alertType = alertType;
      }

      if (alertCategory) {
        param.alertCategory = alertCategory;
      }

      if (zoneCategoryCode) {
        param["equipment.zone.category.code"] = zoneCategoryCode;
      }

      if (zoneId) {
        param['equipment.zone.id'] = zoneId;
      }

      if (equipmentCategoryLevel1Id) {
        param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
      }

      if (equipmentCategoryLevel2Id) {
        param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
      }

      if (equipmentCategoryLevel3Id) {
        param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
      }

      /** =======================
       *  검색 조건
       * ======================= */
      let keyword = searchKeyword;

      if (searchKeyword) {
        if (!searchField) {
          setSearchField('name');
          keyword = `contains(${searchKeyword})`;
          param['equipment.name'] = keyword;
        } else {
          if (searchField === 'name' || searchField === 'equipmentNo') {
            keyword = `contains(${searchKeyword})`;
          }

          if (searchField === 'name') {
            param['equipment.name'] = keyword;
          } else if (searchField === 'equipmentNo') {
            param['equipment.equipmentNo'] = keyword;
          } else if (searchField === 'modelName') {
            param['equipment.modelName'] = keyword;
          }
        }
      }

      /** =======================
       *  정렬 / 기간 조건
       * ======================= */
      if (equipmentAlertStatus === null || equipmentAlertStatus === '') {
        param.status = ['D', 'F', 'M']
      }

      if (sortModel && sortModel.length > 0) {
        param.sort = [sortModel[0].field+","+sortModel[0].sort];
      } else {
        param.sort = ['status,asc','latestAlertedAt,desc'];
      }

      const now = dayjs().tz(process.env.REACT_APP_TIMEZONE);
      if (periodSearch !== '' && periodSearch >= 0) {
        // 1. 연도 결정 (0~4는 올해, 5~9는 작년)
        const targetYear = now.subtract(Math.floor(periodSearch / 5), 'year');
        
        let start, end;
        const subType = periodSearch % 5;
  
        if (subType === 0) {
          // 전체 연도 (올해 또는 작년)
          start = targetYear.startOf('year'); // 1월 1일 00:00:00
          end = targetYear.endOf('year');     // 12월 31일 23:59:59
        } else {
          // 분기 계산 (subType 1=1분기, 2=2분기...)
          start = targetYear.quarter(subType).startOf('quarter');
          end = targetYear.quarter(subType).endOf('quarter');
        }
  
        const gte = (start.format());
        const lte = (end.format());
  
        param.latestAlertedAt = ['gte(${gte})','and(lte(${lte}))'];
      }

      try {
        /** =======================
         *  1️⃣ 목록 + 페이징
         * ======================= */
        const data = await getEquipmentAlertsByQuery(param);

        if (data?.page) {
          setPageInfo(data.page);
        } else {
          setPageInfo({
            size: pageSize,
            totalElements: 0,
            totalPages: 0,
            number: 0,
          });
        }

        if (data?._embedded) {
          let list = data._embedded.equipmentAlerts;
          list && list.map(function(equipmentAlert, i) {
              equipmentAlert.idx = (i+1);
              equipmentAlert.no = data.page.totalElements-((currentPage)*data.page.size)-i;
          })
          setEquipmentAlerts(list);
          // setEquipmentAlerts(data._embedded.equipmentAlerts);
        } else {
          setEquipmentAlerts([]);
        }

        /** =======================
         *  2️⃣ 그룹 카운트
         * ======================= */
        const res = await getEquipmentAlertsGroupCountByFllwActionType(countParam);

        let equipmentGroupCounts = [];
        let totalEquipmentGroupCount = 0;

        if (res?.data) {
          const statussData = res.data;
          const followActionTypes = getEnumValueByEnumName("FollowActionType");

          if (followActionTypes) {
            followActionTypes.forEach(status => {
              if (status.code === 'O1_WAIT') status.sort = 1;
              if (status.code === 'O4_NORMAL') status.sort = 2;
              if (status.code === 'O2_OBSERVE') status.sort = 3;
              if (status.code === 'O3_MNT') status.sort = 4;
            });

            orderNumber(followActionTypes, "sort");

            followActionTypes.forEach(item1 => {
              let matched = statussData.find(item2 =>
                item2.groups.includes(item1.code)
              );

              if (matched) {
                equipmentGroupCounts.push({
                  name: item1.code,
                  id: item1.code,
                  title: item1.title,
                  count: matched.count,
                });
                totalEquipmentGroupCount += matched.count;
              } else {
                equipmentGroupCounts.push({
                  name: item1.code,
                  id: item1.code,
                  title: item1.title,
                  count: 0,
                });
              }
            });
          }
        }

        setEquipmentGroupCounts(equipmentGroupCounts);
        setTotalEquipmentGroupCount(totalEquipmentGroupCount);

        /** =======================
         *  3️⃣ 엑셀 데이터
         * ======================= */
        const { page, size, ...rest } = param;
        setExcelParam(rest);
        
      } finally {
        setIsLoading(true);
      }
    };

    const dataMappingRules = (column, index, totalElements, startIndex) => {
      const rowNumber = totalElements - (startIndex + index);

      let statusName = '';
      if (column?.fllwActionType === 'O2_OBSERVE') {
        if (column?.atentObserv?.status) { // 주의관찰의 상태값이 있으면
          statusName = getEnumValueByEnumNameAndCode("AttentionObservationStatus",column?.atentObserv?.status)?.[0]?.title;
        }
      } else if (column?.fllwActionType === 'O3_MNT') {
        if (column?.mntTask?.status) {  // 유지보수의 상태값이 있으면
          statusName = getEnumValueByEnumNameAndCode("MaintenanceStatus",column?.mntTask?.status)?.[0]?.title;
        }
      }

      let rowData = [
        rowNumber,
        getEnumValueByEnumNameAndCode("EquipmentAlertStatus", column.status)?.[0]?.title || '',
        getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType)?.[0]?.title || '',
        statusName,
        column.fieldChkedAt ? fromServerFormat(column.fieldChkedAt, {format:t('message.common.text.date.format.datetime')}) : '',
        column.latestAlertedAt ? fromServerFormat(column.latestAlertedAt, {format:t('message.common.text.date.format.datetime')}) : '',
        column?.fieldChkUser || '',
        getEnumValueByEnumNameAndCode("AlertType", column.alertType)?.[0]?.title || '',
        getEnumValueByEnumNameAndCode("AlertCategory", column.alertCategory)?.[0]?.title || '',
        column.equipment?.managementCompany?.info?.name || '',
        column.equipment?.maintenanceCompany?.info?.name || '',
        column.equipment?.equipmentCtgr?.parent?.parent?.name || '',
        column.equipment?.equipmentCtgr?.name || '',
        column.equipment?.name || '',
        column.equipment?.equipmentNo || '',
        column.equipment?.manufacturingCompany?.info?.name || '',
        column.equipment?.modelName || ''
      ];

      if (platformServer === 'NANTONG') {
        rowData.splice(9, 2)

        // 호선, 역사 추가
        rowData.splice(9, 0, ((column.equipment?.zone?.category?.name?.[i18n.language.substring(0, 2)]) || '')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
        rowData.splice(10, 0, ((column.equipment?.zone?.name) || '')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      }

      return rowData;
    };
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
  
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      fetchEquipmentAlerts(0);
      // setExcelDatas([]);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (equipmentFollowActionType) {searchParamCopy.searchFollowActionType = equipmentFollowActionType};
      if (equipmentFollowActionStatus) {searchParamCopy.searchFollowActionStatus = equipmentFollowActionStatus};
      if (alertType) {searchParamCopy.searchAlertType = alertType};
      if (alertCategory) {searchParamCopy.searchAlertCategory = alertCategory};
      if (equipmentAlertStatus) {searchParamCopy.searchStatus = equipmentAlertStatus};
      if (zoneCategoryCode) {searchParamCopy.searchSubway = zoneCategoryCode};
      if (zoneId) {searchParamCopy.searchStation = zoneId};
      if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
      if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
      if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
      if (periodSearch >= 0) {searchParamCopy.periodSearch = periodSearch};
      
      setSearchParam(searchParamCopy)

      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    const handleMobileOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleMobileSearch = (event) => {
      handleSearch(event)
      handleClose();
    };

    const statusTapSearch = (vCode, sCode=null) => {
      setCurrentPage(0);
      setPageInfo(prev => ({ ...prev, number: 0 })); // 새 객체 전달
      setEquipmentFollowActionStatus(sCode);
      setEquipmentFollowActionType(vCode);
      initSearch();

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      searchParamCopy.searchFollowActionType = vCode;
      searchParamCopy.searchFollowActionStatus = sCode;
      searchParamCopy.searchKeyword = '';
      searchParamCopy.searchStatus = '';
      searchParamCopy.searchSubway = '';
      searchParamCopy.searchStation = '';
      searchParamCopy.searchlevel1 = '';
      searchParamCopy.searchlevel2 = '';
      searchParamCopy.searchlevel3 = '';
      searchParamCopy.periodSearch = '';
      searchParamCopy.alertType = '';
      searchParamCopy.alertCategory = '';
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');

      // setTimeout을 아주 짧게 주어 Call Stack을 분리하면 안정성이 올라갑니다.
      setTimeout(() => {
        navigate({
          pathname: location.pathname, // 현재 경로 유지
          search: `?${paramString}`,
        }, { replace: true }); // 히스토리 꼬임 방지
      }, 0);
    };
  
    const initSearch = ()  => {
      setEquipmentAlertStatus('');
      setZoneCategoryCode('');
      setZoneId('');
      setEquipmentCategoryLevel1Id('');
      setEquipmentCategoryLevel2Id('');
      setEquipmentCategoryLevel3Id('');
      setPeriodSearch('');
      setAlertType('');
      setAlertCategory('');
      setSearchKeyword('');
      setCurrentPage(0);
      // setIsLoading(false);
      requestRefresh();
      // setExcelDatas([]);
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        setOpen(false);
      }
    };

    
    // 세부 상태 데이터 매핑 정의
    const SUB_STATUS_MAP = {
      'O2_OBSERVE': getEnumValueByEnumName("AttentionObservationStatus"),
      'O3_MNT': getEnumValueByEnumName("MaintenanceStatus")
      // 'O3_MNT': getEnumValueByEnumName("MaintenanceStatus").filter(ma=>ma.code !== 'O4_V')
    };
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeItemId, setActiveItemId] = useState(null);

    const handleLiClick = (e, itemId) => {
      // 세부 상태가 존재하는 조치인지 확인 (item.id가 SUB_STATUS_MAP에 있는지)
      if (SUB_STATUS_MAP[itemId]) {
        setAnchorEl(e.currentTarget); // 팝업 띄울 위치 지정
        setActiveItemId(itemId);
      } else {
        // 세부 상태가 없으면 기존처럼 바로 검색 호출
        statusTapSearch(itemId);
        handleSubClose();
      }
    };

    const handleSubStatusClick = (subStatusId) => {
      // 부모 ID와 세부 상태 ID를 함께 넘겨서 검색 처리
      statusTapSearch(activeItemId, subStatusId);
      handleSubClose();
    };

    const handleSubClose = () => {
      setAnchorEl(null);
      setActiveItemId(null);
    };

    const subItemStyle = {
      padding: '6px 16px',
      cursor: 'pointer',
      color: '#fff',
      fontSize: '13px',
      hover: { backgroundColor: '#2a3446' } // 실제 구현 시 css 클래스로 처리
    };

    const equipmentCategorySearchPermission = hasPermission(PERMISSIONS.EQUIPMENT_CATEGORY_SEARCH);

    return (
      <div className="sub_container">
        <div className='search_section'>
          <ul className='condition' style={{marginTop:"px"}}>
            <li>{t('message.common.subtitle.fllwActionType')}</li>
            <li className={`sum${followActionTypeSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.total')}: {totalEquipmentGroupCount}</li>
            {equipmentGroupCounts &&
              equipmentGroupCounts.map(function(item, i) {
                followActionTypeSelectColor = item.id === equipmentFollowActionType ? " selected" : "";
                const hasSubStatus = !!SUB_STATUS_MAP[item.id]; // 세부 상태 보유 여부

                return (
                  <React.Fragment key={i}>
                  <li
                    key={item.id}
                    className={`${item.id}${followActionTypeSelectColor}`} 
                    onClick={(e) => handleLiClick(e, item.id)}
                    style={{cursor:"pointer"}}>
                    {item.title}: {item.count} 
                    {hasSubStatus && equipmentFollowActionStatus && item.id === equipmentFollowActionType &&
                      `(${SUB_STATUS_MAP[equipmentFollowActionType].find(f=>f.code === equipmentFollowActionStatus)?.title ?? t('message.common.total')})`}
                  </li>
                  </React.Fragment>
                )
              }) }

              {/* 세부 상태 선택 미니 팝업 레이어 (MUI Menu나 커스텀 Div로 대체 가능) */}
              {anchorEl && activeItemId && (
                <div style={{
                  position: 'absolute',
                  top: '35px', // li 크기에 맞춰 조절
                  left: anchorEl.offsetLeft + 65,
                  backgroundColor: '#202632', // 기존 다크 모드 톤에 맞춤
                  border: '1px solid #3f485a',
                  borderRadius: '4px',
                  padding: '4px 0',
                  zIndex: 999,
                  boxShadow: '0px 4px 10px rgba(0,0,0,0.5)'
                }}>
                  {/* '전체' 보기 선택지 하나 추가해주면 유용합니다 */}
                  <div className="sub-item" onClick={() => { statusTapSearch(activeItemId); handleSubClose(); }} style={subItemStyle}>
                    {/* {equipmentGroupCounts.find(p => p.id === activeItemId)?.title}  */}
                    {t('message.common.total')}
                  </div>
                  {SUB_STATUS_MAP[activeItemId].map((sub) => (
                    <div 
                      key={sub.code} 
                      className="sub-item" 
                      onClick={() => handleSubStatusClick(sub.code)}
                      style={subItemStyle}
                    >
                      {sub.title}
                    </div>
                  ))}
                </div>
              )}
          </ul>
          
          <div className="selectbox">
            <div className="desktop_serach">
                <Box component="form">
                <div>
                {getEnumValueByEnumName("EquipmentAlertStatus") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={equipmentAlertStatus}
                      label={t('message.common.subtitle.status')}
                      labelName={t('message.common.subtitle.status')}
                      name={'equipmentAlertStatus'}
                      defaultValue={equipmentAlertStatus}
                      onChange={(e)=>{
                        setEquipmentAlertStatus(e.target.value);
                      }}
                      list={getEnumValueByEnumName("EquipmentAlertStatus")}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("AlertType") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={alertType}
                      label={t('message.common.subtitle.alertType')}
                      labelName={t('message.common.subtitle.alertType')}
                      name={'alertType'}
                      defaultValue={alertType}
                      onChange={(e)=>{
                        setAlertType(e.target.value);
                      }}
                      list={getEnumValueByEnumName("AlertType")}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("AlertCategory") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={alertCategory}
                      label={t('message.common.subtitle.alertCategory')}
                      labelName={t('message.common.subtitle.alertCategory')}
                      name={'alertCategory'}
                      defaultValue={alertCategory}
                      onChange={(e)=>{
                        setAlertCategory(e.target.value);
                      }}
                      list={getEnumValueByEnumName("AlertCategory")}
                  />
                  </FormControl>
                  }
                  {(platformServer === 'NANTONG' && zoneCategories) &&
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={`${zoneCategoryCode}-${zoneCategoryCode.length}`}
                      label={t('message.common.subtitle.subwayline')}
                      labelName={t('message.common.subtitle.subwayline')}
                      name={'subway'}
                      defaultValue={zoneCategoryCode}
                      onChange={(e)=>{
                        setZoneCategoryCode(e.target.value);
                        setZoneId('')
                      }}
                      list={zoneCategories}
                  />
                  </FormControl>
                  }
                  {(platformServer === 'NANTONG' && zones ) && (
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={`${zoneId}-${zones.length}`}
                      label={t('message.common.subtitle.station')}
                      labelName={t('message.common.subtitle.station')}
                      name={'station'}
                      value={zoneId}
                      // defaultValue={zones ? zoneId : ''}
                      onChange={(e)=>{
                        setZoneId(e.target.value)
                      }}
                      list={zones}
                  />
                  </FormControl>
                  )}
                  {equipmentCategorySearchPermission && equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {equipmentCategorySearchPermission && equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {equipmentCategorySearchPermission && equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  {/* {periodSearchSelectItems && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={periodSearch}
                      label={t('message.common.select.alertPeriod')}
                      labelName={t('message.common.select.alertPeriod')}
                      name={'periodSearch'}
                      defaultValue={periodSearch}
                      onChange={(e)=>{
                        setPeriodSearch(e.target.value);
                      }}
                      list={selectPeriodOptions}
                  />
                  </FormControl>
                  } */}
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={searchField}
                      label={t('message.common.btn.search')}
                      labelName={t('message.common.btn.search')}
                      name={'searchField'}
                      defaultValue={searchField}
                      onChange={(e)=>{
                        setSearchField(e.target.value);
                      }}
                      list={searchFields}
                  />
                  </FormControl>
                  }
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>
  
                    <Button variant="contained" style={{marginTop:"0",padding:"10px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                    </div>
                </div>
                </Box>
            </div>

            <div className="mobile_serach" style={{display:"none"}}>
                <Button style={{width:"100%",marginBottom:"10px"}} variant="contained" color="secondary" onClick={handleClickOpen}>
                    {t('message.common.text.search.category.open')}
                </Button>
                <Dialog className="mobile_serach_box" disableEscapeKeyDown open={open} onClose={handleClose}>
                    <DialogTitle>{t('message.common.text.search.category.select')}</DialogTitle>
                    <DialogContent>
                    <Box component="form">
                        <div>
                        {getEnumValueByEnumName("EquipmentAlertStatus") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                            key={equipmentAlertStatus}
                            label={t('message.common.subtitle.status')}
                            labelName={t('message.common.subtitle.status')}
                            name={'equipmentAlertStatus'}
                            defaultValue={equipmentAlertStatus}
                            onChange={(e)=>{
                                setEquipmentAlertStatus(e.target.value);
                            }}
                            list={getEnumValueByEnumName("EquipmentAlertStatus")}
                        />
                        </FormControl>
                        }
                        {getEnumValueByEnumName("AlertType") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={alertType}
                            label={t('message.common.subtitle.alertType')}
                            labelName={t('message.common.subtitle.alertType')}
                            name={'alertType'}
                            defaultValue={alertType}
                            onChange={(e)=>{
                              setAlertType(e.target.value);
                            }}
                            list={getEnumValueByEnumName("AlertType")}
                        />
                        </FormControl>
                        }
                        {getEnumValueByEnumName("AlertCategory") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={alertCategory}
                            label={t('message.common.subtitle.alertCategory')}
                            labelName={t('message.common.subtitle.alertCategory')}
                            name={'alertCategory'}
                            defaultValue={alertCategory}
                            onChange={(e)=>{
                              setAlertCategory(e.target.value);
                            }}
                            list={getEnumValueByEnumName("AlertCategory")}
                        />
                        </FormControl>
                        }
                        {equipmentCategorySearchPermission && equipmentCategoryLevel1s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={equipmentCategoryLevel1Id}
                            label={t('message.common.subtitle.equipment.level1')}
                            labelName={t('message.common.subtitle.equipment.level1')}
                            name={'level1'}
                            defaultValue={equipmentCategoryLevel1Id}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel1Id(e.target.value);
                                setEquipmentCategoryLevel2Id('');
                                setEquipmentCategoryLevel3Id('');
                            }}
                            list={equipmentCategoryLevel1s}
                        />
                        </FormControl>
                        }
                        {equipmentCategorySearchPermission && equipmentCategoryLevel2s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={equipmentCategoryLevel2Id}
                            label={t('message.common.subtitle.equipment.level2')}
                            labelName={t('message.common.subtitle.equipment.level2')}
                            name={'level2'}
                            defaultValue={equipmentCategoryLevel2Id}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel2Id(e.target.value);
                                setEquipmentCategoryLevel3Id('');
                            }}
                            list={equipmentCategoryLevel2s}
                        />
                        </FormControl>
                        }
                        {equipmentCategorySearchPermission && equipmentCategoryLevel3s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={equipmentCategoryLevel3Id}
                            label={t('message.common.subtitle.equipment.level3')}
                            labelName={t('message.common.subtitle.equipment.level3')}
                            name={'level3'}
                            defaultValue={equipmentCategoryLevel3Id}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel3Id(e.target.value);
                            }}
                            list={equipmentCategoryLevel3s}
                        />
                        </FormControl>
                        }
                        {periodSearchSelectItems && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={periodSearch}
                            label={t('message.common.select.alertPeriod')}
                            labelName={t('message.common.select.alertPeriod')}
                            name={'periodSearch'}
                            defaultValue={periodSearch}
                            onChange={(e)=>{
                              setPeriodSearch(e.target.value);
                            }}
                            list={selectPeriodOptions}
                        />
                        </FormControl>
                        }
                        <div style={{display:"inline-block"}}>
                        {searchFields && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                            key={searchField}
                            label={t('message.common.btn.search')}
                            labelName={t('message.common.btn.search')}
                            name={'searchField'}
                            defaultValue={searchField}
                            onChange={(e)=>{
                                setSearchField(e.target.value);
                            }}
                            list={searchFields}
                        />
                        </FormControl>
                        }
                            <FormControl sx={{ m: 1 }} variant="standard">
                            <BootstrapInput id="demo-customized-textbox" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleMobileOnKeyPress}/>
                            </FormControl>
                        </div>
                    </div>
                    </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleMobileSearch} variant="contained">{t('message.common.btn.search')}</Button>
                        <Button onClick={handleClose} variant="contained" color="secondary">{t('message.common.btn.cancel')}</Button>
                    </DialogActions>
                </Dialog>
            </div>
          </div>
        </div>
        
        <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
          <DataGridPro
            rows={equipmentAlerts && equipmentAlerts !== undefined ? equipmentAlerts : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />
        
          <div className="btn_right">
              <div className='no-print-page'>
                <CommonLargeExcelDownload 
                  title={excelTitle}
                  excelHeader={excelTopHeaders}
                  excelParam={excelParam}
                  fetchApiFn={getEquipmentAlertsByQuery} // 👈 액시오스 함수 매핑
                  mappingFn={dataMappingRules}               // 👈 파싱 룰 데이터 매핑
                  apiKey="equipmentAlerts"                          // 👈 JSON 응답 타겟 키 지정
                  pageSize={5000}                                   // 백엔드 제한 수치 수용
                  totalCount={pageInfo.totalElements}
                />
              </div>
          </div>
          
          <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
        </Box>

      </div>
    );
}

export default EquipmentAlertHistoryTrackingMonitoring;